var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("h4", { staticClass: "request-panel-title" }, [
              _vm._v("\n        General\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "request-panel" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Date")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 18 } },
                          [
                            _c("time-zone-formatter", {
                              attrs: { "current-time": _vm.getNewDate },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Type")]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 18 } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.requestInProgress.general.type) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Agent")]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 18 } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.requestInProgress.general.requester.email
                              ) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Area")]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 18 } }, [
                          _vm._v(
                            "\n              Customer Support\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h4", { staticClass: "request-panel-title" }, [
              _vm._v("\n        Customer Information\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "request-panel" },
              [
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Email")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.requestInProgress.customer.customer_email
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Full Name")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.requestInProgress.customer.customer_name) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Phone")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.requestInProgress.customer.customer_phone
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h4", { staticClass: "request-panel-title" }, [
              _vm._v("\n        Customer Address\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "request-panel" },
              [
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Address")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.requestInProgress.address.customer_address_1
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.requestInProgress.address.customer_address_2
                  ? _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Address 2")]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 18 } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.requestInProgress.address.customer_address_2
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("City")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.requestInProgress.address.customer_city) +
                          ", " +
                          _vm._s(_vm.requestInProgress.address.customer_state) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Country")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.requestInProgress.address.customer_country
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Zip")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.requestInProgress.address.customer_zip) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.shouldShowReturnMessage(_vm.requestInProgress)
        ? _c("el-alert", { attrs: { type: "warning", closable: false } }, [
            _c("div", [
              _vm._v("\n      Important note that requests for "),
              _c("b", [_vm._v("non-domestic U.S.")]),
              _vm._v(
                " addresses will not receive a label email from UPS. Manual submission of return label required.\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h4", { staticClass: "request-panel-title" }, [
              _vm._v("\n        Product Information\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "request-panel" },
              [
                _vm.requestInProgress.general.type !== "parts"
                  ? _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Product")]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 18 } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.currentProduct.description) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.requestInProgress.general.type !== "parts"
                  ? _c(
                      "el-row",
                      { attrs: { span: 20 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("b", [_vm._v("Color")]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 18 } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.requestInProgress.product
                                  .new_device_color || "--------"
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.requestInProgress.general.type !== "parts"
                              ? "Reasons"
                              : "Parts"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 18 } },
                      _vm._l(
                        _vm.requestInProgress.reasons.reasons,
                        function (reason) {
                          return _c("div", { key: reason.id }, [
                            _vm._v(
                              "\n              (" +
                                _vm._s(reason.quantity || 1) +
                                ")\n              " +
                                _vm._s(_vm.getReason(reason.id).text) +
                                "\n            "
                            ),
                          ])
                        }
                      ),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h4", { staticClass: "request-panel-title" }, [
              _vm._v("\n        Request Information\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "request-panel" },
              [
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Retailer")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.requestInProgress.misc.purchase_location ||
                              "N/A"
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Order No.")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.requestInProgress.misc.order_number || "------"
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Kustomer Url")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c(
                        "a",
                        {
                          staticClass: "request-kustomer-link",
                          staticStyle: { "text-decoration": "none" },
                          attrs: {
                            href: _vm.requestInProgress.misc.zendesk_id,
                            target: "_blank",
                          },
                        },
                        [_c("span", [_vm._v("Go to kustomer")])]
                      ),
                      _vm._v(" "),
                      _c("small", [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: { click: _vm.copyToClipboard },
                          },
                          [
                            _c("i", {
                              class: _vm.kustomerUrlCopiedText
                                ? "el-icon-check"
                                : "el-icon-copy-document",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.kustomerUrlCopiedText ? "Copied" : "Copy"
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { id: "copy-kustomer-url", type: "hidden" },
                        domProps: {
                          value: _vm.requestInProgress.misc.zendesk_id,
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Expedited")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c("i", {
                        staticClass: "el-icon",
                        class: {
                          "el-icon-success text-success":
                            _vm.requestInProgress.misc.expedited,
                          "el-icon-error text-error":
                            !_vm.requestInProgress.misc.expedited,
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Return First")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c("i", {
                        staticClass: "el-icon",
                        class: {
                          "el-icon-success text-success":
                            _vm.requestInProgress.misc.receive_first,
                          "el-icon-error text-error":
                            !_vm.requestInProgress.misc.receive_first,
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { span: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("b", [_vm._v("Return Label")]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c("i", {
                        staticClass: "el-icon",
                        class: {
                          "el-icon-success text-success":
                            _vm.requestInProgress.reasons.return_label,
                          "el-icon-error text-error":
                            !_vm.requestInProgress.reasons.return_label,
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showShipping
        ? _c(
            "el-row",
            { staticClass: "form-row", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("h4", { staticClass: "request-panel-title" }, [
                  _vm._v("\n        Shipping Information\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingPrice,
                        expression: "loadingPrice",
                      },
                    ],
                    staticClass: "request-panel",
                  },
                  [
                    _vm.price.id
                      ? _c(
                          "div",
                          [
                            !_vm.price.in_stock || _vm.price.out_of_stock
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-alert",
                                          {
                                            attrs: {
                                              title:
                                                "This product is out of stock.",
                                              type: "error",
                                              "show-icon": "",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  "Estimated back stock date is\n                  "
                                                ),
                                                _c("time-zone-formatter", {
                                                  attrs: {
                                                    "current-time":
                                                      _vm.price.restock_dt,
                                                  },
                                                }),
                                                _vm._v(".\n                "),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-row",
                                          { attrs: { span: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                _c("b", [
                                                  _vm._v("Force Stock A"),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 18 } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.requestInProgress.misc
                                                        .stock_a
                                                        ? "Yes"
                                                        : "No"
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.price.product.description
                                          ? _c(
                                              "el-row",
                                              { attrs: { span: 20 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 6 } },
                                                  [_c("b", [_vm._v("Product")])]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 18 } },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.price.product
                                                            .description
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.price.sku
                                          ? _c(
                                              "el-row",
                                              { attrs: { span: 20 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 6 } },
                                                  [_c("b", [_vm._v("SKU")])]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 18 } },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm._f("uppercase")(
                                                            _vm.price.sku
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-row",
                                          { attrs: { span: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [_c("b", [_vm._v("Stock")])]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 18 } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm._f("uppercase")(
                                                        _vm.price.stock
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-row",
                                          { attrs: { span: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [_c("b", [_vm._v("Market")])]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 18 } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(_vm.price.market) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-row",
                                          { attrs: { span: 20 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [_c("b", [_vm._v("Estimated")])]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 18 } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.requestInProgress.misc
                                                        .expedited
                                                        ? "1 working day"
                                                        : "5 working days"
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "el-divider el-divider--horizontal" }),
      _vm._v(" "),
      _vm.isReplacement
        ? _c("el-alert", {
            attrs: {
              type: "warning",
              description:
                "Ring Neighbors will be sent an equal or better device depending on stock availability of the device requested.",
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "el-input" },
        [
          _c("el-switch", {
            model: {
              value: _vm.request_reviewed,
              callback: function ($$v) {
                _vm.request_reviewed = $$v
              },
              expression: "request_reviewed",
            },
          }),
          _vm._v(" "),
          _c("label", [_vm._v("I have verified the request information")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "center-buttons" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.backStep(2)
                },
              },
            },
            [_vm._v("\n      Back\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.request_reviewed, type: "danger" },
              on: { click: _vm.submit },
            },
            [_vm._v("\n      Submit\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }